<template>
  <div class="vendor-form">
    <p class="vendor-form-label">
      {{ label }}<span class="text-ast" v-if="isRequired">*</span>
    </p>
    <div class="form-list-usaha">
      <div class="list-usaha">
        <div class="list-usaha-content list-usaha-content__title">
          <p v-for="(table, index) in tables" :key="index" :class="table.css">
            {{ table.name }}
          </p>
        </div>
        <div v-for="(list, index) in model" :key="index">
          <div>
            <div class="list-usaha-content">
              <p v-for="(table, i) in tables" :key="i" :class="table.css">
                <span v-if="!table.input"><i class="fas fa-download mr10" v-if="table.type == 'file' &&
        $get(list, `${table.obj_name}.path`)
        " @click="downloadFile($get(list, `${table.obj_name}.path`))"></i>{{
        table.type == 'file'
          ? $get(list, `${table.obj_name}.original_name`)
          : list[table.obj_name]
      }}</span>
                <input style="width: 90%" :type="table.type" v-model="model[index][list[table.obj_name]]"
                  v-if="table.input" :disabled="disabled" />
              </p>
              <p class="column5" @click="edit(list.id)" v-if="canEditOrDelete() && !disabled">
                <i class="fa fa-edit"></i>
              </p>
              <p class="column5" @click="deleteData(list.id, list.request_id)" v-if="canEditOrDelete() && !disabled">
                <i class="fas fa-trash-alt"></i>
              </p>
            </div>
          </div>
        </div>
        <div @click="openModal()" class="btn-landing-icons" v-if="!disabled">
          <p class="icons-btn-landing">+</p>
          <a class="text-btn-landing" v-if="canEditOrDelete()">Tambah</a>
          <a class="text-btn-landing" v-else>Tambah / Edit</a>
        </div>
      </div>
    </div>
    <AddBidangUsahaGems v-if="$store.state[storeName].modal_add_bidang_usaha_gems" :label="'Bidang Usaha GEMS'"
      :modalName="'modal_add_bidang_usaha_gems'" :modelName="'addedBidangUsahaGems'"
      :mutationName="'kplhStore/SET_KPLH_FORM'" :storeName="'kplhStore'" />
    <add-sistem-manajemen v-if="$store.state[storeName].modal_add_sistem_manajemen" :label="'Sistem Manajemen'"
      :modalName="'modal_add_sistem_manajemen'" :modelName="'addedSistemManajemen'"
      :mutationName="'k3lStore/SET_K3L_FORM'" :arrayMutation="'k3lStore/SET_ARRAY_DATA'" :storeName="'k3lStore'" />
    <addIUJPnonInti v-if="$store.state[storeName].modal_add_iujp_non_inti" :label="'Bidang Usaha Pertambangan Non Inti'"
      :modalName="'modal_add_iujp_non_inti'" :modelName="'addedIUJPnonInti'" :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'" />
    <addCompetencies v-if="$store.state[storeName].modal_add_competencies"
      :label="'Daftar Karyawan dengan Sertifikat Kompetensi'" :modelName="'addedCompetencies'"
      :mutationName="'k3lStore/SET_K3L_FORM'" :arrayMutation="'k3lStore/SET_ARRAY_DATA'" :storeName="'k3lStore'"
      :modalName="'modal_add_competencies'" />
    <addGoldenRules v-if="$store.state[storeName].modal_add_golden_rules" :label="'Golden Rules'"
      :modelName="'addedGoldenRules'" :isRequired="false" :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'" :modalName="'modal_add_golden_rules'" />
  </div>
</template>
<script>
import axios from 'axios'
import { api_lp } from '@/services/config'
import AddSistemManajemen from '../customModal/add-sistem-manajemen.vue'
import AddBidangUsahaGems from '../customModal/addBidangUsahaGems.vue'
export default {
  props: [
    'label',
    'isRequired',
    'tables',
    'storeName',
    'modelName',
    'modalName',
    'mutationName',
    'operationAdd',
    'disabled',
    'editMutation',
  ],
  components: {
    addIUJPnonInti: () => import("@/components/customModal/addIUJPnonInti.vue"),
    addCompetencies: () => import("@/components/customModal/add-competencies.vue"),
    addGoldenRules: () => import("@/components/customModal/addGoldenRules.vue"),
    AddSistemManajemen,
    AddBidangUsahaGems
  },
  data() {
    return {
      labelPlaceholder: 'UPLOAD',
    }
  },
  computed: {
    model: function () {

      return this.$store.state[this.storeName][this.modelName]
    },
  },
  methods: {
    canEditOrDelete() {
      switch (this.modelName) {
        case 'addedIUJPnonInti':
          return false
          break
        case 'addedGoldenRules':
          return false
          break

        default:
          return true
          break
      }
    },
    openModal() {
      this.$store.commit(this.mutationName, {
        name: this.modalName,
        value: true,
      })
      this.$store.commit(this.mutationName, {
        name: this.operationAdd,
        value: true,
      })
    },
    generateEditUrl(route, id) {
      switch (route) {
        case 'modal_add_competencies':
          return `${api_lp}/api/v1/vendor/sertifikat-kompetentsi/${id}`
          break
        case 'modal_add_sistem_manajemen':
          return `${api_lp}/api/v1/vendor/sistem-manajemen-id/${id}`
          break

        default:
          break
      }
    },
    generateDeleteUrl(route, id, request_id) {
      switch (route) {
        case 'modal_add_competencies':
          return `${api_lp}/api/v1/vendor/sertifikat-kompetentsi/${id}/${request_id}`
          break
        case 'modal_add_sistem_manajemen':
          return `${api_lp}/api/v1/vendor/sistem-manajemen/${id}/${request_id}`
          break

        default:
          break
      }
    },
    async edit(id) {
      try {
        let url = this.generateEditUrl(this.modalName, id)

        await this.$store.commit(this.mutationName, {
          name: this.modalName,
          value: true,
        })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          this.$store.commit(this.editMutation, data.data)
        }
      } catch (error) {
        console.log(
          '🚀 ~ file: input-fill-form.vue ~ line 135 ~ edit ~ error',
          error
        )
      }
    },

    async deleteData(id, request_id) {
      try {
        let url = this.generateDeleteUrl(this.modalName, id, request_id)
        const { data } = await axios({
          method: 'DELETE',
          url,
        })

        if (data && data.status == 'success') {
          await this.$store.commit(this.mutationName, {
            name: this.modelName,
            value: data.data,
          })
          this.$store.commit('SET_NOTIF', 'Data berhasil di hapus.')
        }
      } catch (error) {
        console.log(
          '🚀 ~ file: input-fill-form.vue ~ line 158 ~ delete ~ error',
          error
        )
      }
    },

    async downloadFile(link) {
      if (link) {
        let linkUrl = `${api_lp}/k3l-file/${link}`
        await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
        await axios({
          url: linkUrl,
          method: 'GET',
          responseType: 'blob',
        })
          .then(async response => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]))
            let fileLink = document.createElement('a')

            fileLink.href = fileURL
            fileLink.setAttribute('download', this.$linkConverter(link))
            document.body.appendChild(fileLink)

            fileLink.click()

            await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          })
          .catch(async error => {
            await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          })
      }
    },
  },
}
</script>
